(function () {
  angular.module('MktzapApp.Controllers')
    .controller('FixCardsController', fixCardsController);

  fixCardsController.$inject = ['FixCardsService', 'NotificationService'];

  function fixCardsController (FixCardsService, NotificationService) {
    var vm = this;
    vm.callCommand = callCommand;

    function callCommand () {
      FixCardsService
        .callCommand({})
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, 'Command executado');
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro na execução do command!');
        });
    }
  }
})();
